import React, {useCallback, useEffect, useMemo, useState} from 'react'

import { useDispatch, useSelector } from 'react-redux'

import {TextField, Button, Typography, Paper, Select, MenuItem, NativeSelect, InputLabel, OutlinedInput, FormControl, ListItem, ListItemText, IconButton, Grid} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';
import useStyles from './styles.js'
import { createPlayer, updatePlayer } from '../../../actions/players.js'
import { useTheme } from '@mui/styles'
import { discipline_all, getActualSeason, season_all } from '../../../bdd/bddSTUB.js'
import { getUserProvider, isAdminDSAS  } from '../../../actions/auth.js'
import SelectGroupProvider from '../../../dsasComponents/SelectGroupProvider.js'
import { fetchCompetitions, fetchPlayerById, fetchTeams } from '../../../api/index.js'
import DatePicker_Dsas from '../../../dsasComponents/DatePicker_Dsas.js'
import { useFetch } from '../../../filters/useFetch.js';
import { FETCH_ALL_COMPETITION, FETCH_ALL_TEAM } from '../../../constants/actionTypes.js';
import Select_Dsas from '../../../dsasComponents/Select_Dsas.js';

function getStyles(name, personName, theme) {
    return {
        fontWeight:
        personName.indexOf(name) === -1
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,
    };
}

const initialForm = {
    firstname : '', 
    lastname : '', 
    teams : [], 
    teamsSeason : [],
    discipline : '', 
    number : '', 
    photo : '',
    birthday : null,
    nationality : '',
    size : '',
    weight : '',
    positioning : '',
    thirdPartyId : '',
    thirdPartyEntityId: '',

    

    provider : getUserProvider()
}
const FormPlayer = ({ currentId, setCurrentId = () => {}, position = 'fixed', onValidate = () => {}}) => {
    const classes = useStyles();
    const theme = useTheme();

    const dispatch = useDispatch()

    const [playerData, setPlayerData] = useState(initialForm)

    // FILTERS
    const [filters, setFilters] = useState({discipline : '', competition : '', teams : '', provider : '', season : getActualSeason()})

    const [teams, loadingTeam] = useFetch(fetchTeams, filters, ['competition'], FETCH_ALL_TEAM)

    const competitions_filters = useMemo(() => {
        return {...filters, teams : ''}

    }, [filters])

    const [competitions, loadingCompetition] = useFetch(fetchCompetitions, competitions_filters, undefined, FETCH_ALL_COMPETITION)

    useEffect(() => {
        setFilters(s=> ({...s, competition : '', teams : ''}))
    }, [filters.discipline, filters.season])

    useEffect(() => {

        setFilters(s => ({...s, provider : playerData.provider}))

    }, [playerData.provider])

    useEffect(() => {
        setFilters(s=> ({...s, teams : ''}))
    }, [filters.competition])

    

    useEffect(() => {
        if(currentId){

            // Effectuer requête API
            fetchPlayerById(currentId)
            .then((response) => {
                setPlayerData({...response.data});
            })
            .catch((error) => {
            console.error(error);
            });
        }
    }, [currentId])

    /*const teams_available = useCallback(() => {
        return teams_all
        .filter(t => playerData.discipline==='' || t.discipline === playerData.discipline)
        .filter(t => playerData.provider==='' || t.provider === playerData.provider)
        .sort((a,b) => a.name.localeCompare(b.name))

    }, [playerData.discipline, teams_all, playerData.provider])*/

    const handleSubmit = (e) => {
        e.preventDefault()

        if(!playerData.discipline)
            return

        if(playerData.number === null){
            delete playerData.number
        }

        if(playerData.size === null){
            delete playerData.size
        }

        if(playerData.weight === null){
            delete playerData.weight
        }

        if(playerData.birthday === null){
            delete playerData.birthday
        }

        // Refacto teamsSeason
        playerData.teamsSeason = playerData.teamsSeason.map(t => ({team : t.team._id, startDate : t.startDate, endDate : t.endDate}))

        if(currentId){
            dispatch(updatePlayer(currentId, playerData))
            onValidate()
        }else{
            dispatch(createPlayer(playerData))
        }

        clear()
    }

    const handleChange = (e) => {
        setPlayerData(s => ({...s, [e.target.name]: e.target.value}))

        if(e.target.name === 'discipline'){
            setFilters(state => ({...state, discipline : e.target.value}))
        }
    }

    const handleSelect = (event) => {
        const {target: { value }} = event;

        // On veut valoriser correctement teamsSeason [{team,  startDate, endDate}]
        let teamsSeason = [...playerData.teamsSeason]

        teamsSeason = teamsSeason.filter(t => value.includes(t.team._id))


        value.forEach(teamId => {
            let existingTeam = teamsSeason.find(t => t.team._id === teamId)
            if(!existingTeam){
                teamsSeason.push({team : teams.find(t => t._id === teamId), startDate : new Date().setHours(0, 0, 0, 0), endDate : ''})
            }
        })

        setPlayerData(s => ({...s, teams: value, teamsSeason}))
    };

    const handleSelectImage = (e) => {
        var file = e.target.files[0];
        setPlayerData(s => ({...s, photo: file}))
    }

    const handleSelectDate = (index, name, date) => {
        let teamsSeason = playerData.teamsSeason.map((t, idx) => {
            if(idx === index)
                return {...t, [name] : date }
            
            return {...t}
        })

        setPlayerData(s => ({...s, teamsSeason}))
    }

    const handleDelete = (teamId, index) => {
        // Implémentez ici la logique de suppression de l'équipe
        const teamsSeason = playerData.teamsSeason.filter((t, idx) => idx !== index)
        let teams = playerData.teams

        if(!teamsSeason.find(t => t._id === teamId)){
            teams = teams.filter(t => t !== teamId)
        }

        setPlayerData(s => ({...s, teamsSeason, teams}))
      };
    

    const clear = () => {
        setCurrentId(null)
        setPlayerData(initialForm)
    }

    return (
        <Paper className={classes.paper} sx={{position : position, maxHeight : 600, overflow : 'auto', mr : 5}}>
            <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
                <Typography variant="h6"> {currentId ? "Editer " : "Créer "} un joueur </Typography>

                {/*Discipline*/} 
                <FormControl sx={{ m: 1 }} fullWidth error={!playerData.discipline} >
                    <InputLabel id={"disciplinecompet"}>Discipline</InputLabel>
                    <Select 
                        labelId={'disciplinecompet'}
                        id={"disciplinecompetselect"}
                        name={'discipline'}
                        value={playerData.discipline}
                        label={'Discipline'}
                        onChange={handleChange}
                    >
                        {discipline_all && discipline_all.map(i => (<MenuItem key={i._id} value={i._id}>{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                    </Select>
                </FormControl>

                <TextField 
                    name="lastname" 
                    variant="outlined"
                    label="Nom" 
                    fullWidth 
                    value={playerData.lastname || ''}
                    onChange={handleChange}
                />

                <TextField 
                    name="firstname" 
                    variant="outlined" 
                    label="Prénom" 
                    fullWidth 
                    value={playerData.firstname || ''}
                    onChange={handleChange}
                />

                <TextField 
                    name="number" 
                    variant="outlined"
                    label="Numéro" 
                    fullWidth 
                    value={playerData.number || ''}
                    onChange={handleChange}
                />

                <Select_Dsas
                            className={classes.selectInput}
                            labelId = {"season_label"}
                            label = {"Saison"}
                            selectId = {"season"}
                            name = {"season"}
                            value = {filters.season}
                            items = {season_all}
                            onChange = {(e) => setFilters(state => ({...state, season : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, season : ''}))}
                />

                <Select_Dsas
                            isError = {!filters.competition}
                            className={classes.selectInput}
                            labelId = {"competition_label"}
                            label = {"Compétition"}
                            selectId = {"competition"}
                            name = {"competition"}
                            value = {filters.competition}
                            items = {competitions}
                            onChange = {(e) => setFilters(state => ({...state, competition : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, competition : ''}))}
                />

                <FormControl sx={{ m: 1}} fullWidth>
                    <React.Fragment>
                    <InputLabel id="demo-multiple-name-label">Equipes</InputLabel>
                    <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        multiple
                        value={playerData.teams}
                        variant="outlined"
                        fullWidth 
                        onChange={handleSelect}
                        input={<OutlinedInput label="Equipes" />}
                        >
                        {teams.map((team) => (
                            <MenuItem
                            key={team._id}
                            value={team._id}
                            style={getStyles(team._id, playerData.teams, theme)}
                            >
                            {team.name}
                            </MenuItem>
                        ))}
                    </Select>
                    </React.Fragment>
                </FormControl>

                <div>
                    {playerData.teamsSeason.map((teamInfo, idx) => (
                        <Grid container key={idx} alignItems="center" sx={{background: idx % 2 === 0 ? 'lightgrey' : 'white'}}>
                            <Grid item xs={1}>
                                <IconButton
                                edge="end"
                                aria-label="delete"
                                onClick={() => handleDelete(teamInfo._id, idx)}
                                >
                                <DeleteIcon fontSize="small"/>
                                </IconButton>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="body1">
                                    {`${teamInfo.team.name}`}
                                </Typography>
                            </Grid>
                            
                        <Grid item xs={7}>
                                <DatePicker_Dsas
                                    className="date-picker"
                                    name={`startDate`}
                                    value={teamInfo.startDate}
                                    label="Start Date"
                                    onChange={(date) => handleSelectDate(idx, 'startDate', date && date.setHours(0, 0, 0, 0))}
                                />
                                <DatePicker_Dsas
                                    className="date-picker"
                                    name={`endDate`}
                                    value={teamInfo.endDate}
                                    label="End Date"
                                    onChange={(date) => handleSelectDate(idx, 'endDate', date && date.setHours(23, 59, 59, 999))}
                                />
                        </Grid>
                        </Grid>
                    ))}
                </div>

                <DatePicker_Dsas
                    className="date-picker"
                    name={`birthday`}
                    value={playerData.birthday}
                    label="Date de naissance"
                    onChange={(date) => setPlayerData(p => ({...p, birthday : date}))}
                />

                <TextField 
                    name="size" 
                    variant="outlined"
                    label="Taille (cm)" 
                    fullWidth
                    value={playerData.size || ''}
                    onChange={handleChange}
                />

                <TextField 
                    name="weight" 
                    variant="outlined"
                    label="Poids (kg)" 
                    fullWidth
                    value={playerData.weight || ''}
                    onChange={handleChange}
                />

                <TextField 
                    name="positioning" 
                    variant="outlined"
                    label="Position" 
                    fullWidth
                    value={playerData.positioning || ''}
                    onChange={handleChange}
                />

                <TextField 
                    name="nationality" 
                    variant="outlined"
                    label="Nationalité" 
                    fullWidth
                    value={playerData.nationality || ''}
                    onChange={handleChange}
                />

                
                <TextField 
                    name="thirdPartyEntityId" 
                    variant="outlined"
                    label="Id externe" 
                    fullWidth
                    value={playerData.thirdPartyEntityId || ''}
                    onChange={handleChange}
                />

                <TextField 
                    name="thirdPartyId" 
                    variant="outlined"
                    label="Origine id externe" 
                    fullWidth
                    value={playerData.thirdPartyId || ''}
                    onChange={handleChange}
                />

                <TextField
                label="Photo"
                name="upload-image"
                type="file"
                onChange={handleSelectImage}
                />

                {isAdminDSAS() && <SelectGroupProvider value={playerData.provider} onChange={(e) => setPlayerData(s => ({...s, provider : e.target.value}))}/>}

                <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth> Valider </Button>
                <Button variant="contained" color="secondary" size="small" onClick={clear} fullWidth> Clear </Button>


            </form>

        </Paper>
    )
}

export default FormPlayer